import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function CalendarCash({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>CalendarCash</title>
      <path
        d="M20 10V7C20 5.89543 19.1046 5 18 5H6C4.89543 5 4 5.89543 4 7V10M20 10H4M20 10V11.75M4 10V19C4 20.1046 4.89543 21 6 21H13.5M8 3V7M16 3V7"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M16 19.5381C16 20.3166 16.6238 20.9478 17.3933 20.9478L18.6871 20.9478C19.5116 20.9478 20.18 20.2715 20.18 19.4374C20.18 18.6032 19.5116 17.927 18.6871 17.927L17.4929 17.927C16.6684 17.927 16 17.2508 16 16.4166C16 15.5825 16.6684 14.9062 17.4929 14.9062L18.7867 14.9062C19.5562 14.9062 20.18 15.5374 20.18 16.3159M18.09 14L18.09 14.9062M18.09 20.9478L18.09 21.854"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
